export default "__VITE_ASSET__e9e9fb0e__"